export const SHOW_CREATE_ALERT = 'SHOW_CREATE_ALERT';
export const SHOW_UPDATE_ALERT = 'SHOW_UPDATE_ALERT';
export const AUTH_USER = 'AUTH_USER';
export const SET_CATALOG = 'SET_CATALOG';
export const MANUAL_REQ = "MANUAL_REQ";
export const CREATE_REPORT = "CREATE_REPORT";
export const UPDATE_REPORT = "UPDATE_REPORT";
export const MEDIA_UPLOAD = "MEDIA_UPLOAD";
export const UPDATE_CARPET_BASIC_REPORT = 'UPDATE_CARPET_BASIC_REPORT';
export const RESET_CARPET_BASIC_REPORT = 'RESET_CARPET_BASIC_REPORT';
export const UPDATE_HARDWOOD_DETAILED_REPORT = 'UPDATE_HARDWOOD_DETAILED_REPORT';
export const RESET_HARDWOOD_DETAILED_REPORT = 'RESET_HARDWOOD_DETAILED_REPORT';
export const UPDATE_LAMINATE_REPORT = 'UPDATE_LAMINATE_REPORT';
export const RESET_LAMINATE_REPORT = 'RESET_LAMINATE_REPORT';
export const UPDATE_TILE_REPORT = 'UPDATE_TILE_REPORT';
export const RESET_TILE_REPORT = 'RESET_TILE_REPORT';
export const UPDATE_CARPET_DETAIL_REPORT = 'UPDATE_CARPET_DETAIL_REPORT';
export const RESET_CARPET_DETAIL_REPORT = 'RESET_CARPET_DETAIL_REPORT';
export const UPDATE_LVT_REPORT = 'UPDATE_LVT_REPORT';
export const RESET_LVT_REPORT = 'RESET_LVT_REPORT';
export const UPDATE_HARD_SURFACE_BASIC_REPORT = 'UPDATE_HARD_SURFACE_BASIC_REPORT';
export const RESET_HARD_SURFACE_BASIC_REPORT = 'RESET_HARD_SURFACE_BASIC_REPORT';
export const UPDATE_QUICK_REPORT = 'UPDATE_QUICK_REPORT';
export const RESET_QUICK_REPORT = 'RESET_QUICK_REPORT';
export const UPDATE_NWFA_INSTALLATION_REPORT = 'UPDATE_NWFA_INSTALLATION_REPORT';
export const RESET_NWFA_INSTALLATION_REPORT = 'RESET_NWFA_INSTALLATION_REPORT';
export const UPDATE_NWFA_SAND_FINISH_REPORT = 'UPDATE_NWFA_SAND_FINISH_REPORT';
export const RESET_NWFA_SAND_FINISH_REPORT = 'RESET_NWFA_SAND_FINISH_REPORT';
export const UPDATE_MOHAWK_FIELD_SERVICE_REPORT = 'UPDATE_MOHAWK_FIELD_SERVICE_REPORT';
export const RESET_MOHAWK_FIELD_SERVICE_REPORT = 'RESET_MOHAWK_FIELD_SERVICE_REPORT';

export const FETCH_ANALYTICS_SUMMARY_START = 'FETCH_ANALYTICS_SUMMARY_START';
export const FETCH_ANALYTICS_SUMMARY_SUCCESS = 'FETCH_ANALYTICS_SUMMARY_SUCCESS';
export const FETCH_ANALYTICS_SUMMARY_FAILURE = 'FETCH_ANALYTICS_SUMMARY_FAILURE';
export const FETCH_ACTIVITY_LOGS_START = 'FETCH_ACTIVITY_LOGS_START';
export const FETCH_ACTIVITY_LOGS_SUCCESS = 'FETCH_ACTIVITY_LOGS_SUCCESS';
export const FETCH_ACTIVITY_LOGS_FAILURE = 'FETCH_ACTIVITY_LOGS_FAILURE';
export const SET_ANALYTICS_FILTERS = 'SET_ANALYTICS_FILTERS';

export const FETCH_ALL_USERS_START = 'FETCH_ALL_USERS_START';
export const FETCH_ALL_USERS_SUCCESS = 'FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_FAILURE = 'FETCH_ALL_USERS_FAILURE';

export const FETCH_API_VOLUME_INTERVAL_REQUEST = 'FETCH_API_VOLUME_INTERVAL_REQUEST';
export const FETCH_API_VOLUME_INTERVAL_SUCCESS = 'FETCH_API_VOLUME_INTERVAL_SUCCESS';
export const FETCH_API_VOLUME_INTERVAL_FAIL = 'FETCH_API_VOLUME_INTERVAL_FAIL';
